import React from 'react';
import { Grid, Button } from 'semantic-ui-react';

const ChatRoomsHeader = ({ onOpenAddChatRoomSection }) => (
    <Grid verticalAlign='middle'>
        <Grid.Column width={6}>
            Chat Rooms
        </Grid.Column>
        <Grid.Column width={4} textAlign='right' floated='right'>
        <Button onClick={onOpenAddChatRoomSection} size='tiny' basic inverted color='white'>Add Chat Room</Button>
        </Grid.Column>
    </Grid>
)

export default ChatRoomsHeader;
